<template>
  <div>
    <div class="users" v-if="authenticated">
      <a href="#" v-if="showReg" @click.prevent="show('sub')">Submissions({{submissions.length}})</a><span v-if="!showReg">Submissions({{submissions.length}})</span> |
      <a href="#" v-if="!showReg" @click.prevent="show('reg')">Registrations({{users.length}})</a><span v-if="showReg">Registrations({{users.length}})</span>
      <br>
      <br>
      <div v-if="!showReg">
        <h2 v>Submissions({{submissions.length}})</h2>
        <table>
          <tr class="head">
            <td><b>Title</b></td>
            <td><b>Author</b></td>
            <td><b>Status</b></td>
            <td><b>Link</b></td>
            <td><b>Likes</b></td>
            <td><b>Date</b></td>
            <td><b>Actions</b></td>
          </tr>
          <tr v-for="(submission, index) in submissions" :key="index" >
            <td>{{submission.title}}</td>
            <td>{{submission.author}}</td>
            <td>{{submission.accepted ? 'Live' : 'Pending'}}</td>
            <td v-if="submission.link.service === 'youtube'"><a :href="'https://www.youtube.com/watch?v=' + submission.link.id">Youtube</a></td>
            <td v-if="submission.link.service === 'vimeo'"><a :href="'https://vimeo.com/' + submission.link.id">Vimeo</a></td>
            <td v-if="submission.link.service === 'bilibili'"><a :href="'https://www.bilibili.com/video/av' + submission.link.id">Bilibili</a></td>
            <td>{{submission.likes}}</td>
            <td>{{getDate(submission.date)}}</td>
            <td style="width: 190px">
              <Button class="reject" @click.native="onReject(submission._id, index)" >Reject</Button>
              <Button class="accept" @click.native="onAccept(submission._id, index)" v-if="!submission.accepted">Accept</Button>
              <Button @click.native="onCancel(submission._id, index)" v-if="submission.accepted">Cancel</Button>
            </td>
          </tr>
        </table>
      </div>


      <div v-if="showReg">
        <Button  @click.native="download" class="download">Download Registrations</Button>
        <h2 id="registrations">Registrations({{users.length}})</h2>
        <div class="clear"></div>
        <table>
          <tr class="head">
            <td><b>Name</b></td>
            <td><b>Email</b></td>
            <td><b>Country</b></td>
            <td><b>Status</b></td>
            <td><b>Date</b></td>
          </tr>
          <tr v-for="(user, index) in users" :key="index" >
            <td>{{user.name}}</td>
            <td>{{user.email}}</td>
            <td>{{user.country}}</td>
            <td>{{user.isSubmitted ? 'Submitted' : 'Not submitted'}}</td>
            <td>{{getDate(user.date)}}</td>
          </tr>
        </table>
      </div>
    </div>
  <div class="users" v-if="!authenticated" style="max-width: 400px;">
    <h1>Login</h1>
    <label for="">User</label>
    <input type="text"  v-model="user" >
    <label for="">Password</label>
    <input type="password"  v-model="pass" >
    <div class="field-validation-error" v-if="this.message">{{this.message}}</div>
    <br>
    <br>
    <div class="clear"></div>
    <Button @click.native="login">Login</Button>

    <div class="clear"></div>
  </div>
  </div>

</template>

<script>
import { api } from '@/config'
import axios from 'axios'
import { creatCsvFile, downloadFile, detectionClientType } from 'download-csv';
import Button from '@/components/elements/Button'

export default {

  name: 'DashList',
  components: {
    Button
  },
  data() {
    return {
      showReg: false,
      message: '',
      submissions: [],
      unverified: 0,
      users: [],
      authenticated: false,
      user: '',
      pass: ''
    }
  },
  methods: {
    getDate(date) {
      const trans = new Date(date);

      return `${trans.getDate()}/${trans.getMonth() + 1}/${trans.getFullYear()}`
    },
    login() {
      if(this.user === '' || this.pass === ''){
        this.message = 'Fill all fields'
        return
      }
      axios.post(api.dashList, {
        user: this.user,
        password: this.pass
      }).then(response => {
        if(response.data.status === 'fail' ) {
          this.message = response.errors[0]
        }
        this.submissions = response.data.submissions
        this.users = response.data.users
        this.unverified = response.data.unverifiedSubmissions
        this.authenticated = true
      }).catch(err => {
        if(err.response){
          this.message = err.response.data.errors[0]
        }
        console.log(err)
      })
    },

    onAccept(id, index) {
      axios.post(api.acceptUser, {
        user: this.user,
        password: this.pass,
        submissionId: id
      }).then(response => {
        if(response.data.status === 'fail' ) {
          alert("Error: " + response.errors[0])
        }

        this.submissions[index].accepted = true;
      }).catch(err => {
        console.log(err)
        if(err.response) {
          alert("Error: " + err.response.data.errors[0])
        }

      })
    },
    onCancel(id, index) {
      axios.post(api.cancelAccept, {
        user: this.user,
        password: this.pass,
        submissionId: id
      }).then(response => {
        if(response.data.status === 'fail' ) {
          alert("Error: " + response.errors[0])
        }
        this.submissions[index].accepted = false;
      }).catch(err => {
        console.log(err)
        if(err.response) {
          alert("Error: " + err.response.data.errors[0])
        }
      })
    },
    onReject(id, index) {
      const confirm = window.confirm("Are you sure you want to reject this user? Rejecting a user will remove his submission as well as his registration, and he will have to register for the competition again.");
      if(confirm) {
      } else {
        return
      }
      axios.post(api.rejectUser, {
        user: this.user,
        password: this.pass,
        submissionId: id
      }).then(response => {
        if(response.data.status === 'fail' ) {
          alert("Error: " + response.errors[0])
        }
        this.submissions.splice(index, 1)
      }).catch(err => {
        console.log(err.response)
        if(err.response) {
          alert("Error: " + err.response.data.errors[0])
        }
      })
    },
    download() {
      const columns = { name: 'Name', email: 'Email', country: 'Country' , isSubmitted: 'Status', date: 'Date'}
      downloadFile(creatCsvFile(this.users, columns), 'registrations.csv')
    },
    show(type) {
      if(type === 'reg') {
        this.showReg = true
      }
      if(type === 'sub') {
        this.showReg = false
      }
    }
  },

}
</script>

<style lang="scss" scoped>
.users {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
}
table{
  width: 100%;
}
table td {
  padding:10px;
  border-bottom: 1px solid #ccc;

}
tr {
  margin-bottom: -2px;
  &:nth-child(2n) {
    background: #eee;
  }
}
tr.head {
  background: #666;
  color:#fff;
}
button {
  margin: 0;
  display: inline-block;
  padding: 7px 10px 8px 10px;
}
.accept {
  background: blue;
}
.reject {
  background: gray;
  margin-right: 10px;
  padding: 5px 10px 6px 10px;
}
.download {
  margin-bottom: 30px;
  float:right;
}
</style>
